
























import Vue from 'vue';
import { mapActions } from 'vuex';
import Import from './Import.vue';
import { ModalSize } from '@/components/zen_modal/types';
import { RecordCount } from './types';

export default Vue.extend({
  name: 'ImportCard',
  components: {
    Import,
  },
  props: {
    title: {
      type: String,
      default: 'Import data',
    },
    allowedObjectType: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.$emit('updateConfig', { size: ModalSize.Medium });
  },
  async created() {
    this.changeModalSize(ModalSize.Large);
  },
  methods: {
    ...mapActions({
      confirm: 'modals/confirm',
      cancel: 'modals/cancel',
      showAlert: 'alerts/show',
      changeModalSize: 'modals/changeSize',
    }),
    imported(status: RecordCount) {
      const total = status.created + status.updated;
      let message = `${total} request${total === 1 ? '' : 's'} imported successfully.`;
      if (this.$attrs['extended-message']) {
        message = `${message} <br> ${this.$attrs['extended-message']}`;
      }
      this.showAlert({
        type: 'success',
        message: message,
      });
      this.confirm();
    },
  },
});
